import { render, staticRenderFns } from "./google_sheets.vue?vue&type=template&id=f23dc926"
import script from "./google_sheets.vue?vue&type=script&setup=true&lang=js"
export * from "./google_sheets.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports